/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {BatchInit, Configuration, NetworkApi} from '@adobe/exc-app/network';
import fetchApi from './fetch';
import graphql from './graphql';

//invoked on every configure event
function configure(config: Configuration): void {
  //drill down config to fetch API.
  fetchApi.configure(config);
  //drill down config to graphql API.
  graphql.configure(config);
}

function batch(input: RequestInfo, init?: BatchInit): Promise<Response> {
  //update req with required headers, query params.
  return fetchApi.updateReq(input, init).then(({init, input}) => {
    return graphql.batch(input, init);
  });
}

const network: NetworkApi = {
  batch,
  configure,
  fetch: fetchApi.fetch,
  query: graphql.query
};

export default network;
